module.exports = (parcelRequire.load("jQL9z")).then(() => parcelRequire('1p5xj'));